const modalOverlay = document.querySelector(".modal-overlay");
const videoModal = document.querySelector(".video-modal");
const video = videoModal.querySelector("video");
const playButtons = document.querySelectorAll(".video-modal-play");
const closeButtons = document.querySelectorAll(".video-modal-close");
const externalVideoPoster = document.querySelector(".styling-video-poster");
const externalVideoContainer = document.querySelector(
  ".styling-video-external",
);
const externalVideoPlayButton = document.querySelector(".play-button");
const vimeoIFrame = document.querySelector("#vimeo-video-player-styling");
const vimeoPlayer = vimeoIFrame && new Vimeo.Player(vimeoIFrame);

const toggleModalVisibility = (isVisible) => {
  videoModal.classList.toggle("hidden", !isVisible);
  modalOverlay.classList.toggle("hidden", !isVisible);
};

const openVideoModal = (e) => {
  e.preventDefault();
  toggleModalVisibility(true);
  modalOverlay.addEventListener("click", closeVideoModal);
};

const closeVideoModal = () => {
  if (video) video.pause();
  if (vimeoPlayer) {
    vimeoPlayer.pause();
  }
  toggleModalVisibility(false);
  modalOverlay.removeEventListener("click", closeVideoModal);
};

const handleKeyboardEvent = (e, callback) => {
  if (e.key === "Enter" || e.key === " ") callback(e);
};

playButtons.forEach((button) => {
  const isDesktop = window.matchMedia("(min-width: 768px)").matches;
  if (isDesktop) button.addEventListener("click", openVideoModal);
  button.addEventListener("keydown", (e) =>
    handleKeyboardEvent(e, openVideoModal),
  );
});

closeButtons.forEach((button) => {
  button.addEventListener("click", closeVideoModal);
  button.addEventListener("keydown", (e) =>
    handleKeyboardEvent(e, closeVideoModal),
  );
});

modalOverlay.addEventListener("click", closeVideoModal);

const showExternalVideo = () => {
  externalVideoContainer.classList.remove("hidden");
  externalVideoPoster.classList.add("hidden");
};

if (externalVideoContainer) {
  externalVideoPlayButton.addEventListener("click", showExternalVideo);
}

window.addEventListener("resize", () => {
  const isDesktop = window.matchMedia("(min-width:768px)").matches;
  const desktopStylingVideoContainer = document.getElementById(
    "styling-video-container",
  );
  if (!isDesktop) desktopStylingVideoContainer.classList.add("hidden");
  else desktopStylingVideoContainer.classList.remove("hidden");
});

// Auto loop the video with javascript so we can use the "ended" event listener for data tracking
if (video) {
  video.addEventListener("ended", function () {
    this.play();
  });
}
